module.exports = __webpack_public_path__ + "static/media/mass-video-1.5a74cf46.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/MassTest/mass-video-1.mp4
// module id = 3627
// module chunks = 0